/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useAdminNavigationStyles = makeStyles({
  root: {},
  content: {
    padding: '0 16px',
    flex: 1,
  },
  listItemIcon: {
    minWidth: '30px',
  },
  nestedCollapsibleOffset: {
    marginLeft: '5px',
  },
});
